import { Navigate, useNavigate, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Badge, Button, Icon, Panel, ScreenFrame } from '../ui/index.ts';
import styles from './ComingSoon.module.css';

const FEATURES = [
  'online',
  'profile',
  'collection',
  'leaderboards',
  'news',
  'quick',
  'ranked',
  'private',
  'solo',
  'training',
  'daily',
  'tutorial',
] as const;
type Feature = (typeof FEATURES)[number];

function isFeature(id: string | undefined): id is Feature {
  return FEATURES.some((f) => f === id);
}

/** Honest "not built yet" screen for menu entries that belong to later milestones. */
export function ComingSoon() {
  const { feature } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation('comingSoon');
  const { t: tc } = useTranslation('common');
  const { t: tHome } = useTranslation('home');
  const { t: tPlay } = useTranslation('play');
  if (!isFeature(feature)) return <Navigate to="/404" replace />;
  const titles: Record<Feature, string> = {
    online: tHome('menu.online'),
    profile: tHome('menu.profile'),
    collection: tHome('menu.collection'),
    leaderboards: tHome('menu.leaderboards'),
    news: tHome('menu.news'),
    quick: tPlay('modes.quick.name'),
    ranked: tPlay('modes.ranked.name'),
    private: tPlay('modes.private.name'),
    solo: tPlay('modes.solo.name'),
    training: tPlay('modes.training.name'),
    daily: tPlay('modes.daily.name'),
    tutorial: tPlay('modes.tutorial.name'),
  };
  return (
    <ScreenFrame title={titles[feature]}>
      <Panel as="div" className={styles['panel']}>
        <Icon name="lock" size="3rem" />
        <Badge tone="amber">{tc('soon')}</Badge>
        <h2 className={styles['title']}>{t('title')}</h2>
        <p className={styles['body']}>{t('body')}</p>
        <Button
          variant="secondary"
          onClick={() => {
            void navigate('/');
          }}
        >
          {tc('back')}
        </Button>
      </Panel>
    </ScreenFrame>
  );
}
